// Voyage delay derivation — the one place that decides whether a row is
// delayed, ahead or neither
import { cargoIsFullyDischarged } from './shipChanges.js';

export function coerceDelay(value) {
  if (value == null || value === '') return null;
  if (typeof value === 'object') {
    if (value.value != null) return coerceDelay(value.value);
    return null;
  }
  const n = Number(String(value).trim().replace(/[^+0-9.\-]/g, ''));
  return Number.isNaN(n) ? null : n;
}

/** Render-only: parse API voyage_stops (array or JSON string). Never assemble from siblings. */
export function asVoyageStops(raw) {
  if (!raw) return [];
  if (Array.isArray(raw)) return raw;
  if (typeof raw === 'string') {
    try {
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }
  return [];
}

function delayPool(shipment) {
  const stops = asVoyageStops(shipment?.voyage_stops);
  const groups = Array.isArray(shipment?.tracked_groups) ? shipment.tracked_groups : [];
  const rows = groups.length ? groups : stops;
  if (!rows.length) {
    const d = coerceDelay(shipment?.delay_days ?? shipment?.delayDays);
    return d != null ? [d] : [];
  }
  // DISCHARGED lots drop out of hull color. ARRIVED/at_port still mix.
  // delayed+on-time → delayed; ahead+on-time → ahead; delayed+ahead → delayed.
  const remaining = rows.filter((r) => !cargoIsFullyDischarged(r));
  const pool = remaining.length ? remaining : [];
  return pool
    .map((r) => coerceDelay(r?.delay_days ?? r?.delayDays))
    .filter((n) => n != null);
}

/** Max delay of remaining (non-discharged) lots. */
export function maxVoyageDelay(shipment) {
  const nums = delayPool(shipment);
  if (!nums.length) return null;
  return Math.max(...nums);
}

/** Whole-vessel delayed only from cargo still aboard. */
export function voyageHasDelay(shipment) {
  return delayPool(shipment).some((n) => n >= 1);
}

/** Whole-vessel ahead only from cargo still aboard, and none of those delayed. */
export function voyageIsAhead(shipment) {
  const nums = delayPool(shipment);
  if (!nums.length) return false;
  if (nums.some((n) => n >= 1)) return false;
  return nums.some((n) => n <= -1);
}
